import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import { Chip, Stack, Tooltip, Typography } from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";
import { ScrapEyesEventWithReviewData } from "../contexts/ManualReviewEventContext";
import { eventTypeColor } from "components/scrapEyeDataDashboard/VideoPlayer/utils";
import { useMaterials } from "hooks/useMaterials";
import { getLabellingMaterialDisplayName } from "components/scrapEyeLabelling/utils/materialDisplayName";

interface EventFlowItemProps {
  event: ScrapEyesEventWithReviewData;
  isCurrent: boolean;
  showArrow: boolean;
}

export const EventFlowItem = ({
  event,
  isCurrent,
  showArrow,
}: EventFlowItemProps) => {
  const { t } = useTenantTranslation();
  const { materials } = useMaterials();
  const materialDisplayName = getLabellingMaterialDisplayName(
    materials?.find((material) => material.name === event.material) ?? null,
    t
  ).toUpperCase();
  const coMaterialDisplayName = event.coMaterial
    ? getLabellingMaterialDisplayName(
        materials?.find((material) => material.name === event.coMaterial) ??
          null,
        t
      ).toUpperCase()
    : null;
  const isPaired = !isCurrent;

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      {showArrow ? (
        <ArrowRightAltIcon fontSize="small" sx={{ color: "text.secondary" }} />
      ) : null}

      <Stack alignItems="center" spacing={0.5}>
        <Chip
          label={event.eventType.toUpperCase()}
          size="small"
          sx={{
            bgcolor: eventTypeColor(event.eventType),
            color: "white",
            fontWeight: "bold",
            border: isCurrent ? "2px solid" : "1px solid transparent",
            borderColor: isCurrent ? "text.primary" : "transparent",
            opacity: isCurrent ? 1 : 0.9,
            boxShadow: isCurrent ? 2 : 0,
            minWidth: 60,
          }}
        />
        <Stack alignItems="center" spacing={0}>
          <Typography
            variant="caption"
            sx={{
              fontSize: "0.6rem",
              fontWeight: "bold",
              color: "text.primary",
            }}
          >
            {isCurrent ? t("current").toUpperCase() : materialDisplayName}
          </Typography>

          {coMaterialDisplayName !== null ? (
            <Typography
              variant="caption"
              sx={{ fontSize: "0.6rem", color: "text.secondary" }}
            >
              + {coMaterialDisplayName}
            </Typography>
          ) : null}

          <Stack direction="row" spacing={0.5}>
            <Typography
              variant="caption"
              sx={{ fontSize: "0.65rem", color: "text.secondary" }}
            >
              {event.areaLabel}
            </Typography>

            {isPaired && event.comment ? (
              <Tooltip title={event.comment} arrow placement="top">
                <Typography
                  variant="caption"
                  sx={{ fontSize: "0.65rem", color: "text.secondary" }}
                  maxWidth={120}
                  noWrap
                >
                  • {event.comment}
                </Typography>
              </Tooltip>
            ) : null}
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};
